module.exports = __webpack_public_path__ + "img/backup.62bd076.svg";